/**
 * Created by guyavarham on 04/07/2018.
 */

export const IN_NETWORK = 'IN_NETWORK';
export const OUT_OF_NEWTORK = 'OUT_OF_NEWTORK';
export const UNVERIFIED_NETWORK = 'UNVERIFIED_NETWORK';
